import { useFile } from 'helpers';
import type { ImageProps as NextImageProps } from 'next/image';
import Image from 'next/image';

type BaseProps = {
  src: string;
  priority?: boolean;
  alt?: string;
  fill?: boolean;
};

type NativeImgProps = BaseProps &
  Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'fill'>;
type NextImgProps = BaseProps &
  Omit<NextImageProps, 'src' | 'priority' | 'alt'>;

export const Img = ({
  src,
  priority,
  alt = '',
  fill,
  ...props
}: NativeImgProps | NextImgProps) => {
  const image = useFile(src);
  if (!image) return <></>;

  if (image?.includes('http') && !image?.includes('coverstori')) {
    return (
      <img
        src={image}
        alt={alt}
        {...(props as React.ImgHTMLAttributes<HTMLImageElement>)}
      />
    );
  }

  // For Supabase URLs, use Next.js Image component
  const nextImageProps = {
    src: image,
    priority,
    alt,
    fill,
    ...props,
  } as NextImageProps;

  return (Image as any)({ ...nextImageProps });
};
